import { axios, handleError } from '../../lib'
import TYPES from '../types'

const altActivityData = (data) => ({
  type: TYPES.ALT_ACTIVITY_LISTS,
  data,
})

export const getAllActivity = ({ page = 1, count = 10 }) => async (
  dispatch,
) => {
  try {
    const { status, data } = await axios.get(
      `/audit?page=${page}&limit=${count}`,
    )
    if (status === 200) {
      dispatch(altActivityData(data))
    }
  } catch ({ response }) {
    handleError(response)
  }
}

export const getMyActivity = async () => async () => {
  return await axios.get('/audit')
}

export const getSpecificUserActivity = async (email) => {
  return await axios.get(`/audit?email=${email}`)
}
